import { render, staticRenderFns } from "./sfbz.vue?vue&type=template&id=565ed0ba&scoped=true&"
import script from "./sfbz.vue?vue&type=script&lang=js&"
export * from "./sfbz.vue?vue&type=script&lang=js&"
import style0 from "./sfbz.vue?vue&type=style&index=0&id=565ed0ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ed0ba",
  null
  
)

export default component.exports